export const SUPPORTED_LANGUAGES = ['en', 'de', 'fr'];

export const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English', flagCode: 'us' },
  { code: 'de', label: 'German', flagCode: 'de' },
  { code: 'fr', label: 'French', flagCode: 'fr' },
];

// The ad landing pages have no French copy, and fr.json falls back to English,
// so offering French there would render an English page under a "FR" label.
export const LP_LANGUAGE_OPTIONS = LANGUAGE_OPTIONS.filter((option) => option.code !== 'fr');

export const normalizeLanguageCode = (language) => {
  const normalizedLanguage = String(language || '').trim().toLowerCase();

  if (normalizedLanguage === 'us') return 'en';
  if (SUPPORTED_LANGUAGES.includes(normalizedLanguage)) return normalizedLanguage;

  return 'en';
};

export const isSupportedLanguage = (language) => {
  const normalizedLanguage = String(language || '').trim().toLowerCase();

  return normalizedLanguage === 'us' || SUPPORTED_LANGUAGES.includes(normalizedLanguage);
};

export const isGermanLanguage = (language) => normalizeLanguageCode(language) === 'de';

export const getBrowserLocale = (language) => {
  const normalizedLanguage = normalizeLanguageCode(language);

  if (normalizedLanguage === 'de') return 'de-DE';
  if (normalizedLanguage === 'fr') return 'fr-FR';

  return 'en-GB';
};

// Locale-aware number formatting, e.g. 4.81 → "4,81" and 5000 → "5.000" in German.
export const formatNumber = (value, language, options) =>
  new Intl.NumberFormat(getBrowserLocale(language), options).format(Number(value));

// German-only "k" abbreviation for large round numbers, e.g. 300000 → "300k",
// so stats fit on one line. Other locales fall back to the full formatted number.
export const formatAbbreviatedNumber = (value, language) => {
  const numericValue = Number(value);

  if (isGermanLanguage(language) && numericValue >= 1000) {
    const thousands = numericValue / 1000;
    const formattedThousands = Number.isInteger(thousands)
      ? String(thousands)
      : formatNumber(thousands, language, { maximumFractionDigits: 1 });

    return `${formattedThousands}k`;
  }

  return formatNumber(numericValue, language);
};

export const getStripeLocale = (language) => {
  const normalizedLanguage = normalizeLanguageCode(language);

  if (normalizedLanguage === 'de' || normalizedLanguage === 'fr') return normalizedLanguage;

  return null;
};

export const getStoredLanguage = () => normalizeLanguageCode(localStorage.getItem('lang'));
